module.exports = __webpack_public_path__ + "static/media/ALI.9c5453f5.svg";